export const TOKEN = 'user-authorization-token';


// WEBPACK FOOTER //
// ./src/utils/constants/localstoregeConstants.js